"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMinInitialPayment = getMinInitialPayment;
/**
 * Вычисляет минимальный первоначальный взнос по программе
 *
 * Например, стоимость объекта 15 млн, а минимальный первоначальный взнос 20%.
 * Тогда минимальный первоначальный взнос будет 3 млн.
 *
 * @param startPrice - стоимость объекта
 * @param minInitialPaymentPercent - минимальный первоначальный взнос в процентах
 */
function getMinInitialPayment(startPrice, minInitialPaymentPercent) {
  return minInitialPaymentPercent / 100 * startPrice;
}